'use client';

import { Link } from 'react-router-dom';

const footerNav = {
  patient: [
    { label: 'Telemedicina por vídeo', to: '/medicos' },
    { label: 'Consulta domiciliar em casa', href: '#domiciliar' },
    { label: 'Especialidades médicas', href: '#especialidades' },
    { label: 'Como funciona o atendimento', href: '#como-funciona' },
  ],
  partners: [
    { label: 'Programa Indique e Ganhe', to: '/parceiro' },
    { label: 'Área do Afiliado', to: '/parceiro/links' },
    { label: 'Portal Médico', to: '/login' },
  ],
  security: [
    { label: 'Política de Privacidade', to: '/privacidade' },
    { label: 'Termos de Uso', to: '/termos' },
    { label: 'Central de Ajuda & Suporte', to: '/ajuda' },
  ],
};

export function Footer() {
  return (
    <footer className="bg-muted/30 dark:bg-card/40 border-t border-border/80 transition-colors duration-200">
      <div className="container-landing">
        <div className="py-12 md:py-16 grid grid-cols-2 md:grid-cols-4 gap-8 lg:gap-12">
          {/* Brand Column */}
          <div className="col-span-2 md:col-span-1 space-y-4">
            <Link to="/" className="inline-block group" aria-label="Medikei Página Inicial">
              <img src="/logo.png" alt="Medikei" className="h-9 w-auto drop-shadow-sm dark:brightness-110" decoding="async" loading="lazy" />
            </Link>
            <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
              Cuidado médico ágil, humano e acessível. Consultas por vídeo ou no conforto do seu lar com profissionais certificados pelo CFM.
            </p>
          </div>

          {/* Para Você */}
          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              Para você
            </h4>
            <ul className="space-y-2.5">
              {footerNav.patient.map((link) => (
                <li key={link.label}>
                  {link.to ? (
                    <Link
                      to={link.to}
                      className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors font-medium"
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.href}
                      className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors font-medium"
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Para Parceiros */}
          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              Parceiros & Médicos
            </h4>
            <ul className="space-y-2.5">
              {footerNav.partners.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors font-medium"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Segurança & Legal */}
          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-4">
              Segurança & Termos
            </h4>
            <ul className="space-y-2.5">
              {footerNav.security.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-xs sm:text-sm text-muted-foreground hover:text-primary transition-colors font-medium"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Legal Disclaimer & Copyright */}
        <div className="py-6 border-t border-border/80 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Medikei Saúde. Todos os direitos reservados.</p>
          <p className="text-center md:text-right">
            Em casos de emergência médica com risco à vida, acione imediatamente o SAMU (192) ou o serviço de emergência local.
          </p>
        </div>
      </div>
    </footer>
  );
}
